require('./navigation');
require('./slide-map');
require('./effect3d');
require('./libs');

var echo = require('echo-js');

var dom = require('js-utils/dom');
var scrollTo = require('js-utils/scroll-to');

/*
 ;
 (function scrollToAnchor() {
 var id = window.location.hash.substr(1)
 if(id === '')
 return

 var elem = dom.byId(id)
 if(!elem)
 return

 scrollTo(elem)
 })()
 */

dom.on(dom.byTag('html')[0], 'click', e => {
	var t = e.target;

	if ('A' !== t.tagName) {
		return;
	}

	var href = t.getAttribute('href');
	if (!href || '#' !== href.substr(0, 1) || 1 === href.length) {
		return;
	}

	var id = href.substr(1);
	var elem = dom.byId(id);
	if (!elem) {
		return;
	}
	e.preventDefault();

	scrollTo(elem, {
		onEnd: () => document.location.href = href,
		ease: n => --n * n * n + 1,
		speed: dist => Math.max(200, Math.min(2500, dist * 0.5))
	});
});

dom.forEach(dom.byClass('slider'), s => {
	require('./slider')(s);
});


echo(window).init({offset: 2400});
